import { MenuLinkModel, uddannelseslaegeOverviewMenuLink, klarmeldingerMenuLink, vejlederNotaterMenuLink, brugereMenuLink, evalueringsstatistikMenuLink, forloebOverviewMenuLink, vejledereMenuLink, dashboardMenuLink, fileAdministrationMenuLink, kursusoversigtMenu } from "core/layout/shared/MenuLinkProps";
import { DynamicMenu } from "../DynamicMenu";
import MenuProps from "./menuProps";
import config from "../../../../config/config";



export function UddannelsesansvarligMenu({ showNotification, nyhederMenuLink }: MenuProps) {
    const dashboardMenu = dashboardMenuLink();
    const showDashboard = config.showDashboard ?? false;

    const menuLinks: Array<MenuLinkModel> = [
        forloebOverviewMenuLink,
        uddannelseslaegeOverviewMenuLink,
        vejledereMenuLink,
        klarmeldingerMenuLink,
        vejlederNotaterMenuLink,
        evalueringsstatistikMenuLink,
        brugereMenuLink,
        nyhederMenuLink,
        fileAdministrationMenuLink,
        kursusoversigtMenu
    ];

    if (showDashboard)
        menuLinks.unshift(dashboardMenu);

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );
}
